import {dd,store,app} from 'systems/imports'

import BaseApi from 'api/BaseApi'
import { normalize, schema, Array } from 'normalizr';

/**
 */
class Organization extends BaseApi{
  static getClassName(){ return 'Organization' }

  /**
   */
  static gets(input){
    return app.make("axios").get(`v1/organization`,{
        params: {
          with_events: input["with_events"] || 0
        }
      })
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }

}
export default Organization



// WEBPACK FOOTER //
// ./src/api/Organization.js